import { Reveal } from "@/components/Reveal";
import { BookButton } from "@/components/CtaButtons";

export function Booking() {
  return (
    <section id="book" data-testid="booking-section" className="py-28 px-6 md:px-12 bg-surface border-t border-white/10">
      <div className="max-w-4xl mx-auto text-center">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.35em] text-gold uppercase mb-6">Book a Meeting</p>
          <h2 className="font-serif font-light text-4xl md:text-6xl tracking-tight mb-6">
            Facing a complex ER matter? Let's talk.
          </h2>
          <p className="text-muted2 max-w-xl mx-auto leading-relaxed mb-10">
            Book a complimentary 20-minute introductory call to discuss your Employee Relations or People Risk
            challenge and determine the right next step — in complete confidence.
          </p>
          <div className="flex justify-center">
            <BookButton size="lg" testid="booking-band-book" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
